<template>
  <div class="common-title-page">
    <div class="title-wrapper">
      <manufacturer-input ref="manufacturerInput"></manufacturer-input>
      <span class="title">{{
        $t('text.products') | firstLetterCapitalize
      }}</span>
    </div>
    <div class="section-title mb-20 mt-20">
      <b-button
        size="sm"
        variant="outline-success"
        class="min-w-80"
        @click="add()"
        v-if="p('Products.Product Description.Add')"
        >{{ $t('text.add') | firstLetterCapitalize }}</b-button
      >
      <span class="right-float">
        <img src="@/assets/filter.svg" />
        <el-input
          v-model="filter"
          size="mini"
          class="search-input filter-input"
          placeholder="filter by product number or name"
        ></el-input>
      </span>
    </div>
    <el-table
      border
      ref="table"
      :data="tableData"
      size="small"
      class="mb-30 mt-20"
      v-loading="loading"
    >
      <el-table-column :label="$t('text.product_number')" prop="productNumber">
      </el-table-column>
      <el-table-column
        :label="$t('text.name') | firstLetterCapitalize"
        prop="productName"
      >
      </el-table-column>
      <el-table-column
        :label="$t('text.description') | firstLetterCapitalize"
        prop="description"
      >
      </el-table-column>
      <el-table-column
        :label="$t('text.working_capacity') + ' (ml)'"
        prop="workingCapacity"
      >
      </el-table-column>
      <el-table-column label="Clumping Enabled" prop="isClumpingEnabled">
        <template slot-scope="scope">
          <div :class="scope.row.isClumpingEnabled ? 'green-font' : ''">
            {{ scope.row.isClumpingEnabled ? 'Yes' : 'No' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Maximum Allowed Time" prop="predictedTimeFormat">
        <template slot-scope="scope">
          {{ scope.row.predictedTimeFormat }}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('text.action') | firstLetterCapitalize"
        min-width="110"
        fixed="right"
        v-if="p('Products.Product Description.Edit')"
      >
        <template slot-scope="scope">
          <b-button
            size="sm"
            variant="outline-success"
            class="min-w-80"
            @click="edit(scope.row)"
            >{{ $t('text.view') | firstLetterCapitalize }}/{{
              $t('text.edit') | firstLetterCapitalize
            }}</b-button
          >
        </template>
      </el-table-column>
    </el-table>
    <EditProduct ref="editProduct" />
  </div>
</template>

<script>
import EditProduct from '@/components/products/products/EditProduct'
import ManufacturerInput from '@/components/ManufacturerInput'
import ApiService from '@/services/CommonApiService.js'
import { secondFormat } from '@/utils/utils'
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      filter: '',
      timer: ''
    }
  },
  components: {
    EditProduct,
    ManufacturerInput
  },
  mounted() {
    this.getData()
  },
  watch: {
    '$store.state.manufacturer.selectedManufacturer': function() {
      this.getData()
    },
    filter() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.getData, 500)
    }
  },
  methods: {
    getData() {
      if (!this.$store.state.manufacturer.selectedManufacturer) return false
      this.loading = true
      ApiService.GetProductsByManufacturerId(
        this.$store.state.manufacturer.selectedManufacturer.id
      )
        .then(response => {
          this.loading = false
          this.tableData = response.data.data.map(item => {
            let predictedTime = secondFormat(item.predictedTime)
            let predictedTimeFormat = ''
            if (predictedTime[0]) predictedTimeFormat += predictedTime[0] + 'd'
            if (predictedTime[1]) predictedTimeFormat += predictedTime[1] + 'h'
            if (predictedTime[2]) predictedTimeFormat += predictedTime[2] + 'm'
            if (predictedTime[3]) predictedTimeFormat += predictedTime[3] + 's'
            return {
              ...item,
              predictedTimeFormat
            }
          })
          if (this.filter) {
            this.tableData = this.tableData.filter(item => {
              return (
                item.productNumber
                  .toLowerCase()
                  .indexOf(this.filter.toLowerCase()) > -1 ||
                item.productName
                  .toLowerCase()
                  .indexOf(this.filter.toLowerCase()) > -1
              )
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    add() {
      this.$refs.editProduct.openDialog()
    },
    edit(row) {
      this.$refs.editProduct.openDialog()
      let data = JSON.parse(JSON.stringify(row))
      data.predictedTimeH = Math.floor(row.predictedTime / 3600)
      data.predictedTimeM = Math.floor((row.predictedTime % 3600) / 60)
      this.$refs.editProduct.form = data
    }
  }
}
</script>
